import {
  Box,
  Chip,
  Divider,
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import "./CreateJobForm.css";
import { createJob } from "../../Pages/Utils/types";
import { REGIONS } from "../../constants/regions";
import { useRegion } from "../../context/RegionContext";
import { useMasterData } from "../../context/MasterContextProvider";

const SAUDI_AREAS = [
  "Riyadh", "Jeddah", "Makkah", "Madinah", "Dammam", "Khobar", "Dhahran",
  "Tabuk", "Abha", "Buraidah", "Khamis Mushait", "Najran", "Hail", "Jizan", "Arar",
];

const CreateJobForm = ({
  handleJobTitleChange,
  handleWorkPlaceTypeChange,
  handleWorkStateChange,
  handleEmploymentTypeChange,
  handleProfileDescriptionChange,
  handleJobVancanciesChange,
  handleMinExpChange,
  minExperience,
  handleJobExpChange,
  handleSalaryChange,
  skills,
  Experience,
  jobTitle,
  workPlaceType,
  workState,
  employmentType,
  profileDescription,
  error1,
  noOfvancancies,
  setSkills,
  newSkill,
  setNewSkill,
  salary,
  city,
  handleCityChange,
  area,
  handleAreaChange,
}: createJob) => {
  const { region } = useRegion();
  const { states, jobLevels, workTypes, workPlaces } = useMasterData();
  console.log("states: ", states);
  const handleAddSkill = () => {
    if (skills.length < 5) {
      if (newSkill.trim() !== "") {
        const newSkillObject = {
          skillId: `${skills.length + 1}`,
          skillName: newSkill.trim(),
        };
        setSkills([...skills, newSkillObject]);
        setNewSkill("");
      }
    } else {
      alert("Max 5 skills allowed");
    }
  };

  const handleRemoveSkill = (skillToRemove: any) => {
    setSkills(skills.filter((skill: any) => skill !== skillToRemove));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <h3>Job Details</h3>
      <div className="school-img-box">
        <div className="school-form-inner-box">
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
          >
            Job Title
            <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            placeholder="Job Title"
            onChange={handleJobTitleChange}
            value={jobTitle}
            size="small"
            type="text"
            required
            error={!!error1?.jobTitle}
            helperText={error1?.jobTitle}
          />
        </div>
      </div>
      <div className="school-img-box">
        <div className="school-form-inner-box">
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
          >
            Salary
            <span className="secondaryGrayText"> (optional)</span>
          </Typography>
          <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
            <TextField
              placeholder="Min."
              onChange={handleSalaryChange}
              value={salary}
              fullWidth
              size="small"
              type="number"
              onKeyDown={(e) => {
                if (
                  e.key === "e" ||
                  e.key === "E" ||
                  e.key === "-" ||
                  e.key === "+"
                ) {
                  e.preventDefault();
                }
              }}
            />
            <TextField
              placeholder="Max."
              onChange={handleSalaryChange}
              value={salary}
              fullWidth
              size="small"
              type="number"
              onKeyDown={(e) => {
                if (
                  e.key === "e" ||
                  e.key === "E" ||
                  e.key === "-" ||
                  e.key === "+"
                ) {
                  e.preventDefault();
                }
              }}
            />
            <Select
              id="demo-simple-select"
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                    overflowY: "auto",
                    width: 140,
                  },
                },
              }}
              sx={{
                height: "40px",
                fontSize: "14px",
              }}
              defaultValue="AED"
              inputProps={{ "aria-label": "Without label" }}
              required
            >
              <MenuItem value="AED">AED</MenuItem>
              <MenuItem value="USD">USD</MenuItem>
              <MenuItem value="GBP">GBP</MenuItem>
              <MenuItem value="SAR">SAR</MenuItem>
              <MenuItem value="EUR">EUR</MenuItem>
            </Select>
          </div>
        </div>
        <div className="school-form-inner-box">
          {" "}
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
          >
            Job Level
            <span style={{ color: "red" }}>*</span>
          </Typography>
          <Select
            id="demo-simple-select"
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 300,
                  overflowY: "auto",
                  width: 140,
                },
              },
            }}
            sx={{
              height: "40px",
              fontSize: "14px",
            }}
            defaultValue="Entry"
            inputProps={{ "aria-label": "Without label" }}
            required
          >
            {(jobLevels || []).map((level: any) => (
              // React web app should stay English-only; ignore `jobLevelNameAr`
              <MenuItem key={level._id || level.jobLevelId} value={level.jobLevelName}>
                {level.jobLevelName}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>

      {region === REGIONS.SA ? (
        // Saudi Arabia: Country, City, Area
        <>
          <div className="school-img-box">
            <div className="school-form-inner-box">
              <Typography
                variant="body1"
                component="p"
                sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
              >
                Country
                <span style={{ color: "red" }}>*</span>
              </Typography>
              <Box
                sx={{
                  minWidth: 180,
                }}
              >
                <FormControl fullWidth sx={{ width: "100%" }}>
                  <Select
                    id="demo-simple-select-country"
                    value="Saudi Arabia"
                    disabled
                    renderValue={() => (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span>🇸🇦</span>
                        <span>Saudi Arabia</span>
                      </div>
                    )}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                          overflowY: "auto",
                          width: 140,
                        },
                      },
                    }}
                    sx={{
                      height: "40px",
                      fontSize: "14px",
                    }}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="Saudi Arabia">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span>🇸🇦</span>
                        <span>Saudi Arabia</span>
                      </div>
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
            <div className="school-form-inner-box">
              <Typography
                variant="body1"
                component="p"
                sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
              >
                City
                <span style={{ color: "red" }}>*</span>
              </Typography>
              <Box
                sx={{
                  minWidth: 180,
                }}
              >
                <FormControl fullWidth sx={{ width: "100%" }}>
                  <Select
                    id="demo-simple-select"
                    onChange={handleCityChange}
                    value={city || ""}
                    error={!!error1?.city}
                    displayEmpty
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                          overflowY: "auto",
                          width: 140,
                        },
                      },
                    }}
                    sx={{
                      height: "40px",
                      fontSize: "14px",
                    }}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="" disabled>
                      Select City
                    </MenuItem>
                    {states?.map((state) => (
                      <MenuItem key={state.id} value={state.id}>
                        {state.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText error={!!error1?.city}>
                    {error1?.city}
                  </FormHelperText>
                </FormControl>
              </Box>
            </div>
          </div>
          <div className="school-img-box">
            <div className="school-form-inner-box">
              <Typography
                variant="body1"
                component="p"
                sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
              >
                Area
                <span className="secondaryGrayText"> (Optional)</span>
              </Typography>
              <Box
                sx={{
                  minWidth: 180,
                }}
              >
                <FormControl fullWidth sx={{ width: "100%" }}>
                  <Select
                    id="demo-simple-select"
                    onChange={handleAreaChange}
                    value={area || ""}
                    error={!!error1?.area}
                    displayEmpty
                    disabled={!city}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                          overflowY: "auto",
                          width: 140,
                        },
                      },
                    }}
                    sx={{
                      height: "40px",
                      fontSize: "14px",
                    }}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="" disabled>
                      Select Area
                    </MenuItem>
                    {SAUDI_AREAS.map((areaName: string) => (
                      <MenuItem key={areaName} value={areaName}>
                        {areaName}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText error={!!error1?.area}>
                    {error1?.area}
                  </FormHelperText>
                </FormControl>
              </Box>
            </div>
          </div>
        </>
      ) : (
        // UAE: Country (text) + Emirate
        <div className="school-img-box">
          <div className="school-form-inner-box">
            <Typography
              variant="body1"
              component="p"
              sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
            >
              Country
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <Typography
              variant="body1"
              component="p"
              sx={{ fontSize: "16px", fontWeight: "bold", mb: 1 }}
            >
              United Arab Emirates
            </Typography>
          </div>
          <div className="school-form-inner-box">
            <Typography
              variant="body1"
              component="p"
              sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
            >
              Emirate
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <Box
              sx={{
                minWidth: 180,
              }}
            >
              <FormControl fullWidth sx={{ width: "100%" }}>
                <Select
                  id="demo-simple-select"
                  onChange={handleWorkStateChange}
                  value={workState}
                  error={!!error1?.workState}
                  // @ts-ignore
                  helperText={error1.workState}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                        overflowY: "auto",
                        width: 140,
                      },
                    },
                  }}
                  sx={{
                    height: "40px",
                    fontSize: "14px",
                  }}
                  defaultValue="dubai"
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value="abudhabi">Abu Dhabi</MenuItem>
                  <MenuItem value="dubai">Dubai</MenuItem>
                  <MenuItem value="sharjah">Sharjah</MenuItem>
                  <MenuItem value="ajman">Ajman</MenuItem>
                  <MenuItem value="ummalquwain">Umm Al Quwain</MenuItem>
                  <MenuItem value="rasalkhaimah">Ras Al Khaimah</MenuItem>
                  <MenuItem value="fujairah">Fujairah</MenuItem>
                </Select>
                <FormHelperText error={!!error1.workState}>
                  {error1.workState}
                </FormHelperText>
              </FormControl>
            </Box>
          </div>
        </div>
      )}
      <div className="school-img-box">
        <div className="school-form-inner-box">
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
          >
            Years of Experience
            <span style={{ color: "red" }}>*</span>
          </Typography>
          <div className="experience_holder">
            <TextField
              placeholder="Min Exp(years)"
              onChange={handleMinExpChange}
              value={minExperience}
              error={!!error1?.minExperience}
              helperText={error1?.minExperience}
              onKeyDown={(e) => {
                if (
                  e.key === "e" ||
                  e.key === "E" ||
                  e.key === "-" ||
                  e.key === "+"
                ) {
                  e.preventDefault();
                }
              }}
              size="small"
              type="number"
            />{" "}
            <TextField
              placeholder="Max Exp(years)"
              onChange={handleJobExpChange}
              value={Experience}
              error={!!error1?.Experience}
              helperText={error1?.Experience}
              onKeyDown={(e) => {
                if (
                  e.key === "e" ||
                  e.key === "E" ||
                  e.key === "-" ||
                  e.key === "+"
                ) {
                  e.preventDefault();
                }
              }}
              size="small"
              type="number"
            />
          </div>
        </div>
        <div className="school-form-inner-box">
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
          >
            Job Type
            <span style={{ color: "red" }}>*</span>
          </Typography>
          <Box
            sx={{
              minWidth: 180,
            }}
          >
            <FormControl fullWidth sx={{ width: "100%" }}>
              <Select
                id="demo-simple-select"
                onChange={handleEmploymentTypeChange}
                value={employmentType}
                error={!!error1?.employmentType}
                // @ts-ignore
                helperText={error1.employmentType}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                      overflowY: "auto",
                      width: 140,
                    },
                  },
                }}
                sx={{
                  height: "40px",
                  fontSize: "14px",
                }}
                inputProps={{ "aria-label": "Without label" }}
              >
                {workTypes?.map((w: any, idx: number) => (
                  <MenuItem key={w.workTypeId ?? idx} value={w.workTypeName}>
                    {w.workTypeName}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText error={!!error1.employmentType}>
                {error1.employmentType}
              </FormHelperText>
            </FormControl>
          </Box>
        </div>
      </div>
      <div className="school-img-box">
        <div className="school-form-inner-box">
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
          >
            Preferred Industry{" "}
            <span className="secondaryGrayText"> (optional)</span>
          </Typography>

          <Box
            sx={{
              minWidth: 180,
            }}
          >
            <FormControl fullWidth sx={{ width: "100%" }}>
              <Select
                id="demo-simple-select"
                error={!!error1?.workPlaceType}
                // @ts-ignore
                helperText={error1?.workPlaceType}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                      overflowY: "auto",
                      width: 140,
                    },
                  },
                }}
                sx={{
                  height: "40px",
                  fontSize: "14px",
                }}
                defaultValue="IT"
                inputProps={{ "aria-label": "Without label" }}
                required
              >
                <MenuItem value="IT">IT</MenuItem>
                <MenuItem value="Education">Education</MenuItem>
                <MenuItem value="Industrial">Industrial</MenuItem>
                <MenuItem value="Engineering">Engineering</MenuItem>
                <MenuItem value="Oil">Oil & Gas</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </div>
        <div className="school-form-inner-box">
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
          >
            Work Place Type
            <span style={{ color: "red" }}>*</span>
          </Typography>

          <Box
            sx={{
              minWidth: 180,
            }}
          >
            <FormControl fullWidth sx={{ width: "100%" }}>
              <Select
                id="demo-simple-select"
                onChange={handleWorkPlaceTypeChange}
                value={workPlaceType}
                error={!!error1?.workPlaceType}
                // @ts-ignore
                helperText={error1?.workPlaceType}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                      overflowY: "auto",
                      width: 140,
                    },
                  },
                }}
                sx={{
                  height: "40px",
                  fontSize: "14px",
                }}
                defaultValue="Work from Office"
                inputProps={{ "aria-label": "Without label" }}
                required
              >
                {workPlaces?.map((workPlace: any, idx: number) => (
                  <MenuItem
                    key={workPlace.workplaceId ?? idx}
                    value={workPlace.workplaceName}
                  >
                    {workPlace.workplaceName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </div>
      </div>
      <div className="school-img-box" style={{ marginBottom: "10px" }}>
        <div className="school-form-inner-box">
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
          >
            No.of vacancies
            <span className="secondaryGrayText"> (optional)</span>
          </Typography>
          <TextField
            placeholder="No.of Vacancies"
            onChange={handleJobVancanciesChange}
            value={noOfvancancies}
            error={!!error1?.noOfvancancies}
            helperText={error1?.noOfvancancies}
            size="small"
            type="number"
            onKeyDown={(e) => {
              if (
                e.key === "e" ||
                e.key === "E" ||
                e.key === "-" ||
                e.key === "+"
              ) {
                e.preventDefault();
              }
            }}
          />
        </div>
        <div className="school-form-inner-box">
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
          >
            Education
            <span style={{ color: "red" }}>*</span>
          </Typography>

          <Box
            sx={{
              minWidth: 180,
            }}
          >
            <FormControl fullWidth sx={{ width: "100%" }}>
              <Select
                id="demo-simple-select"
                error={!!error1?.workPlaceType}
                // @ts-ignore
                helperText={error1?.workPlaceType}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                      overflowY: "auto",
                      width: 140,
                    },
                  },
                }}
                sx={{
                  height: "40px",
                  fontSize: "14px",
                }}
                defaultValue="Bachelors"
                inputProps={{ "aria-label": "Without label" }}
                required
              >
                <MenuItem value="High">High School Education</MenuItem>
                <MenuItem value="Associate">Associate Degree</MenuItem>
                <MenuItem value="Bachelors">Bachelor's Degree</MenuItem>
                <MenuItem value="Masters">Master's Degree</MenuItem>
                <MenuItem value="PHD">Doctorate (PH.D.)</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </div>
      </div>
      <br />
      <Divider />
      <h3>Job Requirements</h3>
      <div className="school-img-box">
        <div className="school-form-inner-box">
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
          >
            Job Description
            <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            placeholder="Type here..."
            onChange={handleProfileDescriptionChange}
            value={profileDescription}
            error={!!error1?.profileDescription}
            helperText={error1?.profileDescription}
            size="small"
            multiline
            type="textarea"
            rows={7}
            className="profile_desc_text"
          />
        </div>
      </div>
      <div className="school-img-box">
        <div className="school-form-inner-box">
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
          >
            Job Requirements
            <span className="secondaryGrayText"> (optional)</span>
          </Typography>
          <TextField
            placeholder="Type here..."
            error={!!error1?.profileDescription}
            helperText={error1?.profileDescription}
            size="small"
            multiline
            type="textarea"
            rows={7}
            className="profile_desc_text"
          />
        </div>
      </div>
      <div className="school-img-box">
        <div className="school-form-inner-box">
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
          >
            Skills
            <span style={{ color: "red" }}>*</span>
          </Typography>

          <TextField
            placeholder="Add skills"
            value={newSkill}
            onChange={(e) => setNewSkill(e.target.value)}
            size="small"
            type="text"
            error={!!error1?.newSkill}
            // helperText={error1?.newSkill}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === ",") {
                e.preventDefault();
                handleAddSkill();
              }
            }}
          />
        </div>
      </div>
      <Stack direction="row" spacing={1}>
        {skills?.slice(0, 5).map((skill: any, index: any) => (
          <Chip
            key={index}
            label={skill.skillName}
            onDelete={() => handleRemoveSkill(skill)}
          />
        ))}
      </Stack>

      {/* <div>
        <div className="module">
          <button
            className="toggleButton"
            onClick={() => setSkillsExpanded(!skillsExpanded)}
          >
            {skillsExpanded ? "-" : "+"}
          </button>
          <h2 className="question-title">Additional Details (optional)</h2>
        </div>
        {skillsExpanded && (
          <>
            <div className="school-img-box">
              <div className="school-form-inner-box">
                <Typography
                  variant="body1"
                  component="p"
                  sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
                >
                  Industry
                </Typography>
                <TextField
                  placeholder="Industry"
                  onChange={handleIndustryChange}
                  value={industry}
                  size="small"
                  type="text"
                />
              </div>
            </div>
            <div className="school-img-box">
              <div className="school-form-inner-box">
                <Typography
                  variant="body1"
                  component="p"
                  sx={{ fontSize: "14px", fontWeight: "bold", mb: 1 }}
                >
                  Education
                </Typography>
                <TextField
                  placeholder="Education"
                  onChange={handleEducationChange}
                  value={education}
                  size="small"
                  type="text"
                />
              </div>
            </div>
          </>
        )}

        {
          <>
            <div className="module">
              <button
                className="toggleButton"
                onClick={() => setScreeningExpanded(!screeningExpanded)}
              >
                {screeningExpanded ? "-" : "+"}
              </button>
              <h2 className="question-title">
                Pre-Screening Questions (optional)
              </h2>
            </div>

            {screeningExpanded && screeningQuestions && (
              <ScreeningQuestions
                attendeeFormDetails={screeningQuestions}
                setAttendeeFormDetails={setScreeningQuestions}
              />
            )}
          </>
        }
      </div> */}
    </div>
  );
};

export default CreateJobForm;
